'use strict';

var _defineProperty2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _slicedToArray2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _excluded2 = ["className", "bsPrefix", "as"],
    _excluded3 = ["as", "bsPrefix", "variant", "size", "active", "className"],
    _excluded4 = ["as", "bsPrefix", "className"],
    _excluded5 = ["className"],
    _excluded6 = ["as", "className", "type", "tooltip"],
    _excluded7 = ["id", "bsPrefix", "className", "type", "isValid", "isInvalid", "as"],
    _excluded8 = ["bsPrefix", "className", "htmlFor"],
    _excluded9 = ["id", "bsPrefix", "bsSwitchPrefix", "inline", "disabled", "isValid", "isInvalid", "feedbackTooltip", "feedback", "feedbackType", "className", "style", "title", "type", "label", "children", "as"],
    _excluded10 = ["bsPrefix", "type", "size", "htmlSize", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "as"],
    _excluded11 = ["controlId", "as"],
    _excluded12 = ["as", "bsPrefix", "column", "visuallyHidden", "className", "htmlFor"],
    _excluded13 = ["bsPrefix", "className", "id"],
    _excluded14 = ["bsPrefix", "size", "htmlSize", "className", "isValid", "isInvalid", "id"],
    _excluded15 = ["bsPrefix", "className", "as", "muted"],
    _excluded16 = ["bsPrefix", "className", "children", "controlId", "label"],
    _excluded17 = ["className", "validated", "as"],
    _excluded18 = ["bsPrefix", "fluid", "as", "className"],
    _excluded19 = ["bsPrefix", "className", "as"];

function _ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

require("core-js/modules/esnext.global-this.js");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var PropTypes = require('prop-types');

var gatsby = require('gatsby');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var React__default$1 = /*#__PURE__*/_interopDefaultLegacy(React);

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var wmkClass = function wmkClass(name, group) {
  var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "wmk";
  var classes = [prefix + "-" + group, prefix + "-" + group + "-" + name, append];
  return classes.join(" ").trim();
};

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Anchor = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
      to = _ref.to,
      id = _ref.id,
      className = _ref.className,
      target = _ref.target,
      children = _ref.children,
      style = _ref.style,
      speed = _ref.speed,
      mailto = _ref.mailto,
      tel = _ref.tel,
      animate = _ref.animate,
      rel = _ref.rel,
      label = _ref.label;

  var _style = animate ? _objectSpread$3(_objectSpread$3({}, style), {}, {
    transition: "all ".concat(speed, "s ease")
  }) : style;

  var _target = target ? "_" + target.replace("_", "") : null;

  var _rel = _target === "_blank" ? "noopener noreferrer" : rel;

  var prefix = tel ? "tel:" : mailto ? "mailto:" : "";

  var _to = tel ? to.replace(/\D/g, "") : to;

  var _link = tel ? "tel" : mailto ? "mailto" : "anchor";

  return /*#__PURE__*/React__namespace.createElement("a", {
    href: prefix + _to,
    id: id ? id : undefined,
    className: wmkClass(_link, "link", className),
    target: _target,
    rel: _rel,
    ref: ref,
    style: _style,
    "aria-label": label,
    onClick: onClick
  }, children);
});
Anchor.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  to: PropTypes__default["default"].string,
  target: PropTypes__default["default"].oneOfType([PropTypes__default["default"].bool, PropTypes__default["default"].string]),
  id: PropTypes__default["default"].oneOfType([PropTypes__default["default"].bool, PropTypes__default["default"].string]),
  className: PropTypes__default["default"].string,
  style: PropTypes__default["default"].object,
  speed: PropTypes__default["default"].oneOfType([PropTypes__default["default"].number, PropTypes__default["default"].string]),
  mailto: PropTypes__default["default"].bool,
  tel: PropTypes__default["default"].bool,
  animate: PropTypes__default["default"].bool,
  rel: PropTypes__default["default"].oneOfType([PropTypes__default["default"].bool, PropTypes__default["default"].string])
};
Anchor.defaultProps = {
  target: false,
  id: false,
  className: "",
  speed: ".3",
  mailto: false,
  tel: false,
  animate: false
};
var SocialMediaIcon = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var platform = _ref.platform,
      url = _ref.url,
      target = _ref.target,
      className = _ref.className;
  var Icon = platform.Icon,
      name = platform.name;

  var _className = name + (className !== "" ? " " + className : "");

  return /*#__PURE__*/React__namespace.createElement(Anchor, {
    key: name,
    to: url,
    target: target,
    className: _className,
    ref: ref
  }, /*#__PURE__*/React__namespace.createElement(Icon, null), /*#__PURE__*/React__namespace.createElement("span", {
    className: "sr-only sr-only-focusable"
  }, "Open " + name + " page"));
});
SocialMediaIcon.propTypes = {
  platform: PropTypes__default["default"].object.isRequired,
  url: PropTypes__default["default"].string.isRequired,
  target: PropTypes__default["default"].string,
  className: PropTypes__default["default"].string
};
SocialMediaIcon.defaultProps = {
  target: "_blank",
  className: ""
};

var SocialMediaIcons = function SocialMediaIcons(_ref) {
  var query = _ref.query,
      platforms = _ref.platforms,
      className = _ref.className;

  var getPlatform = function getPlatform(platform, platforms) {
    var socialPlatform = null;
    platforms.forEach(function (p) {
      if (platform.toLowerCase().indexOf(p.name) !== -1) {
        socialPlatform = p;
      }
    });
    return socialPlatform;
  };

  var _className = wmkClass("icon", "social", className);

  return /*#__PURE__*/React__namespace.createElement("div", null, query.map(function (icon) {
    var title = icon.title,
        url = icon.url,
        target = icon.target;
    var platform = getPlatform(title, platforms);
    return /*#__PURE__*/React__namespace.createElement(SocialMediaIcon, {
      platform: platform,
      url: url,
      target: target,
      className: _className,
      key: platform.name + "-icon"
    });
  }));
};

SocialMediaIcons.propTypes = {
  query: PropTypes__default["default"].array.isRequired,
  platforms: PropTypes__default["default"].arrayOf([PropTypes__default["default"].object]),
  className: PropTypes__default["default"].string
};
SocialMediaIcons.defaultProps = {
  platforms: [{
    name: "facebook",
    Icon: function Icon() {
      return /*#__PURE__*/React__namespace.createElement("em", null, "error");
    }
  }, {
    name: "twitter",
    Icon: function Icon() {
      return /*#__PURE__*/React__namespace.createElement("em", null, "error");
    }
  }, {
    name: "linkedin",
    Icon: function Icon() {
      return /*#__PURE__*/React__namespace.createElement("em", null, "error");
    }
  }, {
    name: "youtube",
    Icon: function Icon() {
      return /*#__PURE__*/React__namespace.createElement("em", null, "error");
    }
  }, {
    name: "instagram",
    Icon: function Icon() {
      return /*#__PURE__*/React__namespace.createElement("em", null, "error");
    }
  }, {
    name: "pinterest",
    Icon: function Icon() {
      return /*#__PURE__*/React__namespace.createElement("em", null, "error");
    }
  }, {
    name: "yelp",
    Icon: function Icon() {
      return /*#__PURE__*/React__namespace.createElement("em", null, "error");
    }
  }],
  className: ""
};
var WmkLink = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var to = _ref.to,
      target = _ref.target,
      children = _ref.children,
      mailto = _ref.mailto,
      tel = _ref.tel,
      style = _ref.style,
      className = _ref.className,
      label = _ref.label;

  if (target || mailto || tel) {
    return /*#__PURE__*/React__namespace.createElement(Anchor, {
      style: style,
      ref: ref,
      to: mailto ? "mailto:".concat(to || children) : tel ? "tel:".concat(to || children) : to,
      target: target,
      className: className,
      label: label
    }, children);
  } else {
    return /*#__PURE__*/React__namespace.createElement(gatsby.Link, {
      ref: ref,
      to: to,
      style: style,
      className: className,
      "aria-label": label
    }, children);
  }
});
WmkLink.propTypes = {
  to: PropTypes__default["default"].string,
  target: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node.isRequired,
  mailto: PropTypes__default["default"].bool,
  tel: PropTypes__default["default"].bool,
  style: PropTypes__default["default"].object
};

var FlexSpacer = function FlexSpacer(_ref) {
  var className = _ref.className,
      id = _ref.id;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: wmkClass("flex-spacer", "layout", className),
    id: id,
    style: {
      margin: "auto"
    }
  });
};

FlexSpacer.propTypes = {
  className: PropTypes__default["default"].string,
  id: PropTypes__default["default"].string
};
FlexSpacer.defaultProps = {
  id: "",
  className: ""
};

var MainLayout = function MainLayout(_ref) {
  var children = _ref.children,
      Header = _ref.Header,
      Footer = _ref.Footer,
      className = _ref.className;
  var HeaderJSX = Header;
  var FooterJSX = Footer;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: wmkClass('wrap', 'layout'),
    style: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__namespace.createElement(HeaderJSX, null), /*#__PURE__*/React__namespace.createElement("main", {
    className: wmkClass('main', 'layout', className)
  }, children), /*#__PURE__*/React__namespace.createElement(FlexSpacer, null), /*#__PURE__*/React__namespace.createElement(FooterJSX, null));
};

MainLayout.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  Header: PropTypes__default["default"].func,
  Footer: PropTypes__default["default"].func
};
MainLayout.defaultProps = {
  Header: function Header() {
    return /*#__PURE__*/React__namespace.createElement("div", null, "Pass Header JSX");
  },
  Footer: function Footer() {
    return /*#__PURE__*/React__namespace.createElement("div", null, "Pass Footer JSX");
  }
};
var Copyright = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id;
  var year = new Date().getFullYear();
  return /*#__PURE__*/React__namespace.createElement("div", {
    id: id,
    className: wmkClass("copyright", "layout", className),
    ref: ref
  }, "\xA9 ", year, " ", children);
});

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}

var useIsomorphicLayoutEffect = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.useIsomorphicLayoutEffect = void 0;
  exports.useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React__default$1["default"].useLayoutEffect : React__default$1["default"].useEffect;
});
var useScrollPosition = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.useScrollPosition = void 0;
  var isBrowser = typeof window !== "undefined";
  var zeroPosition = {
    x: 0,
    y: 0
  };

  var getClientRect = function getClientRect(element) {
    return element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
  };

  var getScrollPosition = function getScrollPosition(_ref12) {
    var element = _ref12.element,
        useWindow = _ref12.useWindow,
        boundingElement = _ref12.boundingElement;

    if (!isBrowser) {
      return zeroPosition;
    }

    if (useWindow) {
      return {
        x: window.scrollX,
        y: window.scrollY
      };
    }

    var targetPosition = getClientRect((element === null || element === void 0 ? void 0 : element.current) || document.body);
    var containerPosition = getClientRect(boundingElement === null || boundingElement === void 0 ? void 0 : boundingElement.current);

    if (!targetPosition) {
      return zeroPosition;
    }

    return containerPosition ? {
      x: (containerPosition.x || 0) - (targetPosition.x || 0),
      y: (containerPosition.y || 0) - (targetPosition.y || 0)
    } : {
      x: targetPosition.left,
      y: targetPosition.top
    };
  };

  exports.useScrollPosition = function (effect, deps, element, useWindow, wait, boundingElement) {
    var position = React__default$1["default"].useRef(getScrollPosition({
      useWindow: useWindow,
      boundingElement: boundingElement
    }));
    var throttleTimeout = null;

    var callBack = function callBack() {
      var currPos = getScrollPosition({
        element: element,
        useWindow: useWindow,
        boundingElement: boundingElement
      });
      effect({
        prevPos: position.current,
        currPos: currPos
      });
      position.current = currPos;
      throttleTimeout = null;
    };

    useIsomorphicLayoutEffect.useIsomorphicLayoutEffect(function () {
      var _a;

      if (!isBrowser) {
        return undefined;
      }

      var handleScroll = function handleScroll() {
        if (wait) {
          if (throttleTimeout === null) {
            throttleTimeout = setTimeout(callBack, wait);
          }
        } else {
          callBack();
        }
      };

      if (boundingElement) {
        (_a = boundingElement.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', handleScroll, {
          passive: true
        });
      } else {
        window.addEventListener('scroll', handleScroll, {
          passive: true
        });
      }

      return function () {
        var _a;

        if (boundingElement) {
          (_a = boundingElement.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
        } else {
          window.removeEventListener('scroll', handleScroll);
        }

        if (throttleTimeout) {
          clearTimeout(throttleTimeout);
        }
      };
    }, deps);
  };

  exports.useScrollPosition.defaultProps = {
    deps: [],
    element: false,
    useWindow: false,
    wait: null,
    boundingElement: false
  };
});
var lib$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "useScrollPosition", {
    enumerable: true,
    get: function get() {
      return useScrollPosition.useScrollPosition;
    }
  });
});
var Header = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style; //   style["top"] = offset ? offset : 0;

  return /*#__PURE__*/React__namespace.createElement("header", {
    className: wmkClass("header", "layout", className),
    style: style,
    ref: ref
  }, children);
});

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Sticky = function Sticky(_ref) {
  var Alert = _ref.Alert,
      className = _ref.className,
      children = _ref.children,
      absolute = _ref.absolute,
      style = _ref.style,
      zIndex = _ref.zIndex,
      width = _ref.width,
      trigger = _ref.trigger;
  var domPosition = absolute ? "absolute" : "relative";

  var _useState = React.useState({
    y: 0,
    height: 0,
    width: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      headerRect = _useState2[0],
      setHeaderRect = _useState2[1];

  var _useState3 = React.useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollPos = _useState4[0],
      setScrollPos = _useState4[1];

  var _useState5 = React.useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      location = _useState6[0],
      setLocation = _useState6[1];

  var headerRef = React.useRef();
  React.useEffect(function () {
    setLocation(window.location.href);

    var handleResize = function handleResize() {
      setHeaderRect(headerRef.current.getBoundingClientRect());
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [location]);
  lib$1.useScrollPosition(function (_ref2) {
    var currPos = _ref2.currPos;
    setScrollPos(currPos.y * -1);
  });
  var classes = [className];
  var triggerHeight = !Alert && !headerRect.y ? trigger >= 0 ? trigger : headerRect.height : headerRect.y;
  var isTriggered = scrollPos > triggerHeight;
  if (isTriggered) classes.push("stuck");
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", {
    className: wmkClass("sticky-header", "layout", classes.join(" ")),
    style: _objectSpread$2(_objectSpread$2({}, style), {}, {
      position: isTriggered ? "fixed" : domPosition,
      zIndex: zIndex,
      width: width
    })
  }, !isTriggered ? Alert : null, /*#__PURE__*/React__namespace.createElement(Header, {
    ref: headerRef
  }, children)), Alert && isTriggered ? /*#__PURE__*/React__namespace.createElement("div", {
    style: {
      height: headerRect.y
    }
  }) : null, isTriggered && /*#__PURE__*/React__namespace.createElement("div", {
    style: {
      height: headerRect.height
    }
  }));
};

Sticky.propTypes = {
  Alert: PropTypes__default["default"].node,
  className: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node.isRequired,
  absolute: PropTypes__default["default"].bool,
  zIndex: PropTypes__default["default"].number,
  width: PropTypes__default["default"].string,
  trigger: PropTypes__default["default"].number
};
Sticky.defaultProps = {
  Alert: /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null),
  className: "",
  absolute: false,
  zIndex: 1000,
  width: "100%",
  trigger: 0
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */


var isArray = Array.isArray;
var isArray_1 = isArray;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;
/** Built-in value references. */

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$4.toString;
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

var _getRawTag = getRawTag;
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$3.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}

var isSymbol_1 = isSymbol;
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);

  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;
/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);

  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;
/* Built-in method references that are verified to be native. */

var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }

  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
}

var _hashHas = hashHas;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf;
/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;
/* Built-in method references that are verified to be native. */

var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);

  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = _MapCache;
var memoize_1 = memoize;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize_1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;
/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = _memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

var _stringToPath = stringToPath;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }

  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _baseToString = baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }

  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _toKey = toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = _castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MediaQueries = /*#__PURE__*/function () {
  function MediaQueries(breakpoints, _units) {
    _classCallCheck(this, MediaQueries);

    var units = _units ? _units : "px";
    this.breakpoints = breakpoints ? _objectSpread$1({}, breakpoints) : {
      xs: {
        amount: 576,
        units: units
      },
      sm: {
        amount: 768,
        units: units
      },
      md: {
        amount: 992,
        units: units
      },
      lg: {
        amount: 1200,
        units: units
      }
    };
  }

  _createClass(MediaQueries, [{
    key: "_bp",
    value: function _bp(size) {
      return get_1(this, "breakpoints.".concat(size), {
        amount: "error",
        units: "error"
      });
    }
  }, {
    key: "range",
    value: function range(start, end, css, _typeObj) {
      var typeObj = _typeObj ? _typeObj : {
        type: "screen",
        qualifier: "only"
      };

      var startBreaks = this._bp(start);

      var endBreaks = this._bp(end);

      var minFirst = get_1(startBreaks, "amount", NaN) < get_1(endBreaks, "amount", NaN);
      return this.query(typeObj, [{
        feature: minFirst ? "min-width" : "max-width",
        "break": {
          amount: get_1(startBreaks, "amount") + (minFirst ? 0.1 : -0.1),
          units: get_1(startBreaks, "units")
        }
      }, {
        feature: minFirst ? "max-width" : "min-width",
        "break": {
          amount: get_1(endBreaks, "amount") + (minFirst ? -0.1 : 0.1),
          units: get_1(endBreaks, "units")
        }
      }], css);
    }
  }, {
    key: "addSize",
    value: function addSize(size, amount, _units) {
      var units = _units ? _units : "px";
      this.breakpoints[size] = {
        amount: amount,
        units: units
      };
    }
  }, {
    key: "max",
    value: function max(size, css, mediaType) {
      var type = mediaType ? mediaType : {
        type: "screen",
        qualifier: "only"
      };
      return this.query(type, [{
        feature: "max-width",
        "break": this._bp(size)
      }], css);
    }
  }, {
    key: "min",
    value: function min(size, css, mediaType) {
      var type = mediaType ? mediaType : {
        type: "screen",
        qualifier: "only"
      };
      return this.query(type, [{
        feature: "min-width",
        "break": this._bp(size)
      }], css);
    }
  }, {
    key: "only",
    value: function only(css, _type) {
      var type = _type ? _type : "screen";
      return this.query({
        type: type,
        qualifier: "only"
      }, [], css);
    }
  }, {
    key: "_mediaFeature",
    value: function _mediaFeature(feature, breakpoint) {
      var featStr = get_1(breakpoint, "amount", "") + get_1(breakpoint, "units", "");
      return "and (".concat(feature, ": ").concat(featStr, ")");
    }
  }, {
    key: "_mediaType",
    value: function _mediaType(type, qualifier) {
      var _t = type ? type : "all";

      var _q = qualifier === "only" ? " only " : qualifier === "not" ? " not " : " ";

      return "@media".concat(_q).concat(_t);
    }
  }, {
    key: "query",
    value: function query(typeObj, features, css) {
      var _this = this;

      var feats = features.map(function (feat) {
        return _this._mediaFeature(feat.feature, feat["break"]);
      });
      return "".concat(this._mediaType(get_1(typeObj, "type"), get_1(typeObj, "qualifier")), " ").concat(feats.join(" "), "{").concat(css, "}");
    }
  }]);

  return MediaQueries;
}();

var UrlPaths = /*#__PURE__*/function () {
  function UrlPaths(baseUrl, parents) {
    _classCallCheck(this, UrlPaths);

    this.baseUrl = baseUrl;
    this.parents = parents.reduce(function (a, b) {
      var path = b.path,
          subs = b.subs,
          name = b.name;
      a[name] = {
        path: path,
        subs: subs
      };
      return a;
    }, {});
  }

  _createClass(UrlPaths, [{
    key: "url",
    value: function url(name, str) {
      var _str = str ? "/" + str : "";

      return name ? "//" + this.baseUrl + this._getParentPath(name) + _str : "//" + this.baseUrl + _str;
    }
  }, {
    key: "rel",
    value: function rel(name, str) {
      var _str = str ? "/" + str : "";

      return name ? this._getParentPath(name) + _str : _str;
    }
  }, {
    key: "_getParentPath",
    value: function _getParentPath(parent) {
      var _ref = this.parents[parent] ? this.parents[parent] : {
        path: "",
        subs: {}
      },
          path = _ref.path;

      return "/" + path;
    }
  }]);

  return UrlPaths;
}();

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/


var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactJsxRuntime_production_min = createCommonjsModule(function (module, exports) {
  var g = 60103;
  exports.Fragment = 60107;

  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
  }

  var m = React__default$1["default"].__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      n = Object.prototype.hasOwnProperty,
      p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function q(c, a, k) {
    var b,
        d = {},
        e = null,
        l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);

    for (b in a) {
      n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    }

    if (c && c.defaultProps) for (b in a = c.defaultProps, a) {
      void 0 === d[b] && (d[b] = a[b]);
    }
    return {
      $$typeof: g,
      type: c,
      key: e,
      ref: l,
      props: d,
      _owner: m.current
    };
  }

  exports.jsx = q;
  exports.jsxs = q;
});
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactJsxRuntime_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = React__default$1["default"];
      var _assign = objectAssign; // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      exports.Fragment = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        exports.Fragment = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        symbolFor('react.scope');
        symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      }

      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function error(format) {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          printWarning('error', format, args);
        }
      }

      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();

          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return '' + item;
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      } // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.


      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


        if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }

        return false;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }

      function getContextName(type) {
        return type.displayName || 'Context';
      }

      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case exports.Fragment:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              return getComponentName(type.type);

            case REACT_BLOCK_TYPE:
              return getComponentName(type._render);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentName(init(payload));
                } catch (x) {
                  return null;
                }
              }
          }
        }

        return null;
      } // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.


      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: _assign({}, props, {
                value: prevLog
              }),
              info: _assign({}, props, {
                value: prevInfo
              }),
              warn: _assign({}, props, {
                value: prevWarn
              }),
              error: _assign({}, props, {
                value: prevError
              }),
              group: _assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: _assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: _assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.


          return '\n' + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function Fake() {
              throw Error();
            }; // $FlowFixMe


            Object.defineProperty(Fake.prototype, 'props', {
              set: function set() {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });

            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.


        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_BLOCK_TYPE:
              return describeFunctionComponentFrame(type._render);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return '';
      }

      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(Object.prototype.hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }

      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);

            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */


      var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });

          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */


      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            key = '' + maybeKey;
          }

          if (hasValidKey(config)) {
            key = '' + config.key;
          }

          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object


          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props


          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }

          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentName(ReactCurrentOwner$1.current.type);

            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }

          return '';
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
          }

          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */


      var ownerHasKeyUseWarning = {};

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */


      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
          }

          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */


      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return;
          }

          if (Array.isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */


      function validatePropTypes(element) {
        {
          var type = element.type;

          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }

          var propTypes;

          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }

          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentName(type);

            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }

          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */


      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }

      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';

            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendum(source);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = 'null';
            } else if (Array.isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }

            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }

          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)


          if (validType) {
            var children = props.children;

            if (children !== undefined) {
              if (isStaticChildren) {
                if (Array.isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }

                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }

          if (type === exports.Fragment) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.


      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }

      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }

      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      exports.jsx = jsx;
      exports.jsxs = jsxs;
    })();
  }
});
var jsxRuntime = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactJsxRuntime_production_min;
  } else {
    module.exports = reactJsxRuntime_development;
  }
});
var ThemeContext = /*#__PURE__*/React__namespace.createContext({
  prefixes: {}
});

function useBootstrapPrefix(prefix, defaultPrefix) {
  var _React$useContext = React.useContext(ThemeContext),
      prefixes = _React$useContext.prefixes;

  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}

var _excluded = ["as", "disabled"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

function useButtonProps(_ref13) {
  var tagName = _ref13.tagName,
      disabled = _ref13.disabled,
      href = _ref13.href,
      target = _ref13.target,
      rel = _ref13.rel,
      onClick = _ref13.onClick,
      _ref13$tabIndex = _ref13.tabIndex,
      tabIndex = _ref13$tabIndex === void 0 ? 0 : _ref13$tabIndex,
      type = _ref13.type;

  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }

  var meta = {
    tagName: tagName
  };

  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled: disabled
    }, meta];
  }

  var handleClick = function handleClick(event) {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    onClick == null ? void 0 : onClick(event);
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  return [{
    role: 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href: tagName === 'a' && disabled ? undefined : href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}

var Button$2 = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var asProp = _ref.as,
      disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useButtonProps = useButtonProps(Object.assign({
    tagName: asProp,
    disabled: disabled
  }, props)),
      _useButtonProps2 = _slicedToArray2(_useButtonProps, 2),
      buttonProps = _useButtonProps2[0],
      Component = _useButtonProps2[1].tagName;

  return /*#__PURE__*/jsxRuntime.jsx(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button$2.displayName = 'Button';
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

var pascalCase = function pascalCase(str) {
  return str[0].toUpperCase() + camelize(str).slice(1);
}; // TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`


function createWithBsPrefix(prefix) {
  var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref14$displayName = _ref14.displayName,
      displayName = _ref14$displayName === void 0 ? pascalCase(prefix) : _ref14$displayName,
      Component = _ref14.Component,
      defaultProps = _ref14.defaultProps;

  var BsComponent = /*#__PURE__*/React__namespace.forwardRef(function (_ref15, ref) {
    var className = _ref15.className,
        bsPrefix = _ref15.bsPrefix,
        _ref15$as = _ref15.as,
        Tag = _ref15$as === void 0 ? Component || 'div' : _ref15$as,
        props = _objectWithoutProperties(_ref15, _excluded2);

    var resolvedPrefix = useBootstrapPrefix(bsPrefix, prefix);
    return /*#__PURE__*/jsxRuntime.jsx(Tag, _objectSpread2({
      ref: ref,
      className: classnames(className, resolvedPrefix)
    }, props));
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}

var defaultProps$2 = {
  variant: 'primary',
  active: false,
  disabled: false
};
var Button = /*#__PURE__*/React__namespace.forwardRef(function (_ref16, ref) {
  var as = _ref16.as,
      bsPrefix = _ref16.bsPrefix,
      variant = _ref16.variant,
      size = _ref16.size,
      active = _ref16.active,
      className = _ref16.className,
      props = _objectWithoutProperties(_ref16, _excluded3);

  var prefix = useBootstrapPrefix(bsPrefix, 'btn');

  var _useButtonProps3 = useButtonProps(_objectSpread2({
    tagName: as
  }, props)),
      _useButtonProps4 = _slicedToArray2(_useButtonProps3, 2),
      buttonProps = _useButtonProps4[0],
      tagName = _useButtonProps4[1].tagName;

  var Component = tagName;
  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2(_objectSpread2({}, props), buttonProps), {}, {
    ref: ref,
    className: classnames(className, prefix, active && 'active', variant && "".concat(prefix, "-").concat(variant), size && "".concat(prefix, "-").concat(size), props.href && props.disabled && 'disabled')
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps$2;
var Button$1 = Button;
var DEVICE_SIZES$1 = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];

function useCol(_ref17) {
  var as = _ref17.as,
      bsPrefix = _ref17.bsPrefix,
      className = _ref17.className,
      props = _objectWithoutProperties(_ref17, _excluded4);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES$1.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span;
    var offset;
    var order;

    if (typeof propValue === 'object' && propValue != null) {
      span = propValue.span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-".concat(brkPoint) : '';
    if (span) spans.push(span === true ? "".concat(bsPrefix).concat(infix) : "".concat(bsPrefix).concat(infix, "-").concat(span));
    if (order != null) classes.push("order".concat(infix, "-").concat(order));
    if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
  });
  return [_objectSpread2(_objectSpread2({}, props), {}, {
    className: classnames.apply(void 0, [className].concat(spans, classes))
  }), {
    as: as,
    bsPrefix: bsPrefix,
    spans: spans
  }];
}

var Col = /*#__PURE__*/React__namespace.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (props, ref) {
  var _useCol = useCol(props),
      _useCol2 = _slicedToArray2(_useCol, 2),
      _useCol2$ = _useCol2[0],
      className = _useCol2$.className,
      colProps = _objectWithoutProperties(_useCol2$, _excluded5),
      _useCol2$2 = _useCol2[1],
      _useCol2$2$as = _useCol2$2.as,
      Component = _useCol2$2$as === void 0 ? 'div' : _useCol2$2$as,
      bsPrefix = _useCol2$2.bsPrefix,
      spans = _useCol2$2.spans;

  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, colProps), {}, {
    ref: ref,
    className: classnames(className, !spans.length && bsPrefix)
  }));
});
Col.displayName = 'Col';
var Col$1 = Col;
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);

    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;
var propTypes$1 = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: PropTypes__default["default"].string,

  /** Display feedback as a tooltip. */
  tooltip: PropTypes__default["default"].bool,
  as: PropTypes__default["default"].elementType
};
var Feedback = /*#__PURE__*/React__namespace.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref18, ref) {
  var _ref18$as = _ref18.as,
      Component = _ref18$as === void 0 ? 'div' : _ref18$as,
      className = _ref18.className,
      _ref18$type = _ref18.type,
      type = _ref18$type === void 0 ? 'valid' : _ref18$type,
      _ref18$tooltip = _ref18.tooltip,
      tooltip = _ref18$tooltip === void 0 ? false : _ref18$tooltip,
      props = _objectWithoutProperties(_ref18, _excluded6);

  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    className: classnames(className, "".concat(type, "-").concat(tooltip ? 'tooltip' : 'feedback'))
  }));
});
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes$1;
var Feedback$1 = Feedback;
var FormContext = /*#__PURE__*/React__namespace.createContext({});
var FormContext$1 = FormContext;
var FormCheckInput = /*#__PURE__*/React__namespace.forwardRef(function (_ref19, ref) {
  var id = _ref19.id,
      bsPrefix = _ref19.bsPrefix,
      className = _ref19.className,
      _ref19$type = _ref19.type,
      type = _ref19$type === void 0 ? 'checkbox' : _ref19$type,
      _ref19$isValid = _ref19.isValid,
      isValid = _ref19$isValid === void 0 ? false : _ref19$isValid,
      _ref19$isInvalid = _ref19.isInvalid,
      isInvalid = _ref19$isInvalid === void 0 ? false : _ref19$isInvalid,
      _ref19$as = _ref19.as,
      Component = _ref19$as === void 0 ? 'input' : _ref19$as,
      props = _objectWithoutProperties(_ref19, _excluded7);

  var _React$useContext2 = React.useContext(FormContext$1),
      controlId = _React$useContext2.controlId;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check-input');
  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    type: type,
    id: id || controlId,
    className: classnames(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  }));
});
FormCheckInput.displayName = 'FormCheckInput';
var FormCheckInput$1 = FormCheckInput;
var FormCheckLabel = /*#__PURE__*/React__namespace.forwardRef(function (_ref20, ref) {
  var bsPrefix = _ref20.bsPrefix,
      className = _ref20.className,
      htmlFor = _ref20.htmlFor,
      props = _objectWithoutProperties(_ref20, _excluded8);

  var _React$useContext3 = React.useContext(FormContext$1),
      controlId = _React$useContext3.controlId;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check-label');
  return /*#__PURE__*/jsxRuntime.jsx("label", _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classnames(className, bsPrefix)
  }));
});
FormCheckLabel.displayName = 'FormCheckLabel';
var FormCheckLabel$1 = FormCheckLabel;
var FormCheck = /*#__PURE__*/React__namespace.forwardRef(function (_ref21, ref) {
  var id = _ref21.id,
      bsPrefix = _ref21.bsPrefix,
      bsSwitchPrefix = _ref21.bsSwitchPrefix,
      _ref21$inline = _ref21.inline,
      inline = _ref21$inline === void 0 ? false : _ref21$inline,
      _ref21$disabled = _ref21.disabled,
      disabled = _ref21$disabled === void 0 ? false : _ref21$disabled,
      _ref21$isValid = _ref21.isValid,
      isValid = _ref21$isValid === void 0 ? false : _ref21$isValid,
      _ref21$isInvalid = _ref21.isInvalid,
      isInvalid = _ref21$isInvalid === void 0 ? false : _ref21$isInvalid,
      _ref21$feedbackToolti = _ref21.feedbackTooltip,
      feedbackTooltip = _ref21$feedbackToolti === void 0 ? false : _ref21$feedbackToolti,
      feedback = _ref21.feedback,
      feedbackType = _ref21.feedbackType,
      className = _ref21.className,
      style = _ref21.style,
      _ref21$title = _ref21.title,
      title = _ref21$title === void 0 ? '' : _ref21$title,
      _ref21$type = _ref21.type,
      type = _ref21$type === void 0 ? 'checkbox' : _ref21$type,
      label = _ref21.label,
      children = _ref21.children,
      _ref21$as = _ref21.as,
      as = _ref21$as === void 0 ? 'input' : _ref21$as,
      props = _objectWithoutProperties(_ref21, _excluded9);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check');
  bsSwitchPrefix = useBootstrapPrefix(bsSwitchPrefix, 'form-switch');

  var _React$useContext4 = React.useContext(FormContext$1),
      controlId = _React$useContext4.controlId;

  var innerFormContext = React.useMemo(function () {
    return {
      controlId: id || controlId
    };
  }, [controlId, id]);
  var hasLabel = label != null && label !== false && !children;
  var input = /*#__PURE__*/jsxRuntime.jsx(FormCheckInput$1, _objectSpread2(_objectSpread2({}, props), {}, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: as
  }));
  return /*#__PURE__*/jsxRuntime.jsx(FormContext$1.Provider, {
    value: innerFormContext,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      style: style,
      className: classnames(className, label && bsPrefix, inline && "".concat(bsPrefix, "-inline"), type === 'switch' && bsSwitchPrefix),
      children: children || /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [input, hasLabel && /*#__PURE__*/jsxRuntime.jsx(FormCheckLabel$1, {
          title: title,
          children: label
        }), feedback && /*#__PURE__*/jsxRuntime.jsx(Feedback$1, {
          type: feedbackType,
          tooltip: feedbackTooltip,
          children: feedback
        })]
      })
    })
  });
});
FormCheck.displayName = 'FormCheck';
var FormCheck$1 = Object.assign(FormCheck, {
  Input: FormCheckInput$1,
  Label: FormCheckLabel$1
});
var FormControl = /*#__PURE__*/React__namespace.forwardRef(function (_ref22, ref) {
  var bsPrefix = _ref22.bsPrefix,
      type = _ref22.type,
      size = _ref22.size,
      htmlSize = _ref22.htmlSize,
      id = _ref22.id,
      className = _ref22.className,
      _ref22$isValid = _ref22.isValid,
      isValid = _ref22$isValid === void 0 ? false : _ref22$isValid,
      _ref22$isInvalid = _ref22.isInvalid,
      isInvalid = _ref22$isInvalid === void 0 ? false : _ref22$isInvalid,
      plaintext = _ref22.plaintext,
      readOnly = _ref22.readOnly,
      _ref22$as = _ref22.as,
      Component = _ref22$as === void 0 ? 'input' : _ref22$as,
      props = _objectWithoutProperties(_ref22, _excluded10);

  var _React$useContext5 = React.useContext(FormContext$1),
      controlId = _React$useContext5.controlId;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-control');
  var classes;

  if (plaintext) {
    classes = _defineProperty2({}, "".concat(bsPrefix, "-plaintext"), true);
  } else {
    var _classes2;

    classes = (_classes2 = {}, _defineProperty2(_classes2, bsPrefix, true), _defineProperty2(_classes2, "".concat(bsPrefix, "-").concat(size), size), _classes2);
  }

  process.env.NODE_ENV !== "production" ? warning_1(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classnames(className, classes, isValid && "is-valid", isInvalid && "is-invalid", type === 'color' && "".concat(bsPrefix, "-color"))
  }));
});
FormControl.displayName = 'FormControl';
var FormControl$1 = Object.assign(FormControl, {
  Feedback: Feedback$1
});
var FormFloating = createWithBsPrefix('form-floating');
var FormGroup = /*#__PURE__*/React__namespace.forwardRef(function (_ref23, ref) {
  var controlId = _ref23.controlId,
      _ref23$as = _ref23.as,
      Component = _ref23$as === void 0 ? 'div' : _ref23$as,
      props = _objectWithoutProperties(_ref23, _excluded11);

  var context = React.useMemo(function () {
    return {
      controlId: controlId
    };
  }, [controlId]);
  return /*#__PURE__*/jsxRuntime.jsx(FormContext$1.Provider, {
    value: context,
    children: /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
      ref: ref
    }))
  });
});
FormGroup.displayName = 'FormGroup';
var FormGroup$1 = FormGroup;
var defaultProps$1 = {
  column: false,
  visuallyHidden: false
};
var FormLabel = /*#__PURE__*/React__namespace.forwardRef(function (_ref24, ref) {
  var _ref24$as = _ref24.as,
      Component = _ref24$as === void 0 ? 'label' : _ref24$as,
      bsPrefix = _ref24.bsPrefix,
      column = _ref24.column,
      visuallyHidden = _ref24.visuallyHidden,
      className = _ref24.className,
      htmlFor = _ref24.htmlFor,
      props = _objectWithoutProperties(_ref24, _excluded12);

  var _React$useContext6 = React.useContext(FormContext$1),
      controlId = _React$useContext6.controlId;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-label');
  var columnClass = 'col-form-label';
  if (typeof column === 'string') columnClass = "".concat(columnClass, " ").concat(columnClass, "-").concat(column);
  var classes = classnames(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
  process.env.NODE_ENV !== "production" ? warning_1(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.') : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return /*#__PURE__*/jsxRuntime.jsx(Col$1, _objectSpread2({
    ref: ref,
    as: "label",
    className: classes,
    htmlFor: htmlFor
  }, props));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    jsxRuntime.jsx(Component, _objectSpread2({
      ref: ref,
      className: classes,
      htmlFor: htmlFor
    }, props))
  );
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = defaultProps$1;
var FormLabel$1 = FormLabel;
var FormRange = /*#__PURE__*/React__namespace.forwardRef(function (_ref25, ref) {
  var bsPrefix = _ref25.bsPrefix,
      className = _ref25.className,
      id = _ref25.id,
      props = _objectWithoutProperties(_ref25, _excluded13);

  var _React$useContext7 = React.useContext(FormContext$1),
      controlId = _React$useContext7.controlId;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-range');
  return /*#__PURE__*/jsxRuntime.jsx("input", _objectSpread2(_objectSpread2({}, props), {}, {
    type: "range",
    ref: ref,
    className: classnames(className, bsPrefix),
    id: id || controlId
  }));
});
FormRange.displayName = 'FormRange';
var FormRange$1 = FormRange;
var FormSelect = /*#__PURE__*/React__namespace.forwardRef(function (_ref26, ref) {
  var bsPrefix = _ref26.bsPrefix,
      size = _ref26.size,
      htmlSize = _ref26.htmlSize,
      className = _ref26.className,
      _ref26$isValid = _ref26.isValid,
      isValid = _ref26$isValid === void 0 ? false : _ref26$isValid,
      _ref26$isInvalid = _ref26.isInvalid,
      isInvalid = _ref26$isInvalid === void 0 ? false : _ref26$isInvalid,
      id = _ref26.id,
      props = _objectWithoutProperties(_ref26, _excluded14);

  var _React$useContext8 = React.useContext(FormContext$1),
      controlId = _React$useContext8.controlId;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-select');
  return /*#__PURE__*/jsxRuntime.jsx("select", _objectSpread2(_objectSpread2({}, props), {}, {
    size: htmlSize,
    ref: ref,
    className: classnames(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), isValid && "is-valid", isInvalid && "is-invalid"),
    id: id || controlId
  }));
});
FormSelect.displayName = 'FormSelect';
var FormSelect$1 = FormSelect;
var FormText = /*#__PURE__*/React__namespace.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref27, ref) {
  var bsPrefix = _ref27.bsPrefix,
      className = _ref27.className,
      _ref27$as = _ref27.as,
      Component = _ref27$as === void 0 ? 'small' : _ref27$as,
      muted = _ref27.muted,
      props = _objectWithoutProperties(_ref27, _excluded15);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-text');
  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    className: classnames(className, bsPrefix, muted && 'text-muted')
  }));
});
FormText.displayName = 'FormText';
var FormText$1 = FormText;
var Switch = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  return /*#__PURE__*/jsxRuntime.jsx(FormCheck$1, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    type: "switch"
  }));
});
Switch.displayName = 'Switch';
var Switch$1 = Object.assign(Switch, {
  Input: FormCheck$1.Input,
  Label: FormCheck$1.Label
});
var FloatingLabel = /*#__PURE__*/React__namespace.forwardRef(function (_ref28, ref) {
  var bsPrefix = _ref28.bsPrefix,
      className = _ref28.className,
      children = _ref28.children,
      controlId = _ref28.controlId,
      label = _ref28.label,
      props = _objectWithoutProperties(_ref28, _excluded16);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-floating');
  return /*#__PURE__*/jsxRuntime.jsxs(FormGroup$1, _objectSpread2(_objectSpread2({
    ref: ref,
    className: classnames(className, bsPrefix),
    controlId: controlId
  }, props), {}, {
    children: [children, /*#__PURE__*/jsxRuntime.jsx("label", {
      htmlFor: controlId,
      children: label
    })]
  }));
});
FloatingLabel.displayName = 'FloatingLabel';
var FloatingLabel$1 = FloatingLabel;
var propTypes = {
  /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */
  _ref: PropTypes__default["default"].any,

  /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */
  validated: PropTypes__default["default"].bool,
  as: PropTypes__default["default"].elementType
};
var Form = /*#__PURE__*/React__namespace.forwardRef(function (_ref29, ref) {
  var className = _ref29.className,
      validated = _ref29.validated,
      _ref29$as = _ref29.as,
      Component = _ref29$as === void 0 ? 'form' : _ref29$as,
      props = _objectWithoutProperties(_ref29, _excluded17);

  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    className: classnames(className, validated && 'was-validated')
  }));
});
Form.displayName = 'Form';
Form.propTypes = propTypes;
var Form$1 = Object.assign(Form, {
  Group: FormGroup$1,
  Control: FormControl$1,
  Floating: FormFloating,
  Check: FormCheck$1,
  Switch: Switch$1,
  Label: FormLabel$1,
  Text: FormText$1,
  Range: FormRange$1,
  Select: FormSelect$1,
  FloatingLabel: FloatingLabel$1
});
var defaultProps = {
  fluid: false
};
var Container = /*#__PURE__*/React__namespace.forwardRef(function (_ref30, ref) {
  var bsPrefix = _ref30.bsPrefix,
      fluid = _ref30.fluid,
      _ref30$as = _ref30.as,
      Component = _ref30$as === void 0 ? 'div' : _ref30$as,
      className = _ref30.className,
      props = _objectWithoutProperties(_ref30, _excluded18);

  var prefix = useBootstrapPrefix(bsPrefix, 'container');
  var suffix = typeof fluid === 'string' ? "-".concat(fluid) : '-fluid';
  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({
    ref: ref
  }, props), {}, {
    className: classnames(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
  }));
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
var Container$1 = Container;
var DEVICE_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var Row = /*#__PURE__*/React__namespace.forwardRef(function (_ref31, ref) {
  var bsPrefix = _ref31.bsPrefix,
      className = _ref31.className,
      _ref31$as = _ref31.as,
      Component = _ref31$as === void 0 ? 'div' : _ref31$as,
      props = _objectWithoutProperties(_ref31, _excluded19);

  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'row');
  var sizePrefix = "".concat(decoratedBsPrefix, "-cols");
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var cols;

    if (propValue != null && typeof propValue === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-".concat(brkPoint) : '';
    if (cols != null) classes.push("".concat(sizePrefix).concat(infix, "-").concat(cols));
  });
  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({
    ref: ref
  }, props), {}, {
    className: classnames.apply(void 0, [className, decoratedBsPrefix].concat(classes))
  }));
});
Row.displayName = 'Row';
var Row$1 = Row;

var isReactComponent = function isReactComponent(V) {
  return typeof V === "function" && /*#__PURE__*/React__namespace.isValidElement( /*#__PURE__*/React__namespace.createElement(V, null)) || V !== null && /*#__PURE__*/React__namespace.isValidElement(V);
}; //const getComp = (V) => {}


var NullComponent$1 = function NullComponent() {
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null);
};

var FieldName = function FieldName(_ref) {
  var _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? true : _ref$isRequired,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel;
  return /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, {
    lg: 6
  }, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "firstName",
    visuallyHidden: showLabel ? undefined : true
  }, "First Name ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: "text",
    placeholder: "First Name",
    id: "firstName",
    name: "firstName",
    required: isRequired
  })), /*#__PURE__*/React__namespace.createElement(Col$1, {
    lg: 6
  }, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "lastName",
    visuallyHidden: showLabel ? undefined : true
  }, "Last Name ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: "text",
    placeholder: "Last Name",
    id: "lastName",
    name: "lastName",
    required: isRequired
  })));
};

var FieldEmail = function FieldEmail(_ref2) {
  var _ref2$isRequired = _ref2.isRequired,
      isRequired = _ref2$isRequired === void 0 ? true : _ref2$isRequired,
      _ref2$showLabel = _ref2.showLabel,
      showLabel = _ref2$showLabel === void 0 ? false : _ref2$showLabel;
  return /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, null, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "email",
    visuallyHidden: showLabel ? undefined : true
  }, "Email ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: "email",
    placeholder: "Email Address",
    id: "email",
    name: "email",
    required: isRequired
  })));
};

var FieldSingle = function FieldSingle(_ref3) {
  var name = _ref3.name,
      label = _ref3.label,
      isRequired = _ref3.isRequired,
      _ref3$showLabel = _ref3.showLabel,
      showLabel = _ref3$showLabel === void 0 ? false : _ref3$showLabel;
  return /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, null, label && /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: name,
    visuallyHidden: showLabel ? undefined : true
  }, label, " ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: name,
    placeholder: label,
    id: name,
    name: name,
    required: isRequired
  })));
};

var FieldPhone = function FieldPhone(_ref4) {
  var _ref4$isRequired = _ref4.isRequired,
      isRequired = _ref4$isRequired === void 0 ? true : _ref4$isRequired,
      _ref4$showLabel = _ref4.showLabel,
      showLabel = _ref4$showLabel === void 0 ? false : _ref4$showLabel;
  return /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, null, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "phone",
    visuallyHidden: showLabel ? undefined : true
  }, "Phone Number ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: "tel",
    placeholder: "Phone Number",
    id: "phone",
    name: "phone",
    required: isRequired
  })));
};

var FieldAddress = function FieldAddress(_ref5) {
  var _ref5$states = _ref5.states,
      states = _ref5$states === void 0 ? ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Federated States of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Island", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"] : _ref5$states,
      _ref5$isRequired = _ref5.isRequired,
      isRequired = _ref5$isRequired === void 0 ? false : _ref5$isRequired,
      _ref5$showLabel = _ref5.showLabel,
      showLabel = _ref5$showLabel === void 0 ? false : _ref5$showLabel;
  return /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, {
    lg: 12
  }, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "addressStreet",
    visuallyHidden: showLabel ? undefined : true
  }, "Street Address ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: "text",
    placeholder: "Street Address",
    id: "addressStreet",
    name: "addressStreet",
    required: isRequired
  })), /*#__PURE__*/React__namespace.createElement(Col$1, {
    lg: 6
  }, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "addressCity",
    visuallyHidden: showLabel ? undefined : true
  }, "City ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: "text",
    placeholder: "City",
    id: "addressCity",
    name: "addressCity",
    required: isRequired
  })), /*#__PURE__*/React__namespace.createElement(Col$1, {
    lg: 6
  }, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "addressState",
    visuallyHidden: showLabel ? undefined : true
  }, "State ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    as: "select",
    id: "addressState",
    name: "addressState",
    required: isRequired,
    defaultValue: ""
  }, /*#__PURE__*/React__namespace.createElement("option", {
    disabled: true,
    value: ""
  }, "Choose a State"), states.map(function (state, i) {
    return /*#__PURE__*/React__namespace.createElement("option", {
      key: "".concat(state, "-").concat(i)
    }, state);
  }))), /*#__PURE__*/React__namespace.createElement(Col$1, {
    lg: 6
  }, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "addressPostalCode",
    visuallyHidden: showLabel ? undefined : true
  }, "Postal Code ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    type: "text",
    placeholder: "Postal Code",
    id: "addressPostalCode",
    name: "addressPostalCode",
    required: isRequired
  })));
};

var FieldSelect = function FieldSelect(_ref6) {
  var name = _ref6.name,
      label = _ref6.label,
      options = _ref6.options,
      isRequired = _ref6.isRequired,
      _ref6$showLabel = _ref6.showLabel,
      showLabel = _ref6$showLabel === void 0 ? false : _ref6$showLabel;
  return /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, null, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: name,
    visuallyHidden: showLabel ? undefined : true
  }, label, " ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    as: "select",
    id: name,
    name: name,
    required: isRequired,
    defaultValue: ""
  }, /*#__PURE__*/React__namespace.createElement("option", {
    disabled: true,
    value: ""
  }, label), options.map(function (option, i) {
    return /*#__PURE__*/React__namespace.createElement("option", {
      key: option + i
    }, option);
  }))));
};

var FieldCheckbox = function FieldCheckbox(_ref7) {
  var label = _ref7.label,
      name = _ref7.name,
      text = _ref7.text,
      isRequired = _ref7.isRequired,
      _ref7$showLabel = _ref7.showLabel,
      showLabel = _ref7$showLabel === void 0 ? false : _ref7$showLabel;
  return /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, null, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: name,
    className: "show",
    visuallyHidden: showLabel ? undefined : true
  }, label, " ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Check, {
    type: "checkbox",
    id: name,
    name: name,
    label: text,
    required: isRequired
  })));
};

var FieldMessage = function FieldMessage(_ref8) {
  var isRequired = _ref8.isRequired,
      _ref8$showLabel = _ref8.showLabel,
      showLabel = _ref8$showLabel === void 0 ? false : _ref8$showLabel;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, null, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    htmlFor: "message",
    visuallyHidden: showLabel ? undefined : true
  }, "Message ", isRequired ? /*#__PURE__*/React__namespace.createElement("span", null, "*") : null), /*#__PURE__*/React__namespace.createElement(Form$1.Control, {
    as: "textarea",
    rows: 3,
    placeholder: "Message",
    id: "message",
    name: "message",
    required: isRequired
  }))));
};

var FieldRadio = function FieldRadio(_ref9) {
  var options = _ref9.options,
      _ref9$inline = _ref9.inline,
      inline = _ref9$inline === void 0 ? true : _ref9$inline,
      name = _ref9.name,
      label = _ref9.label,
      showLabel = _ref9.showLabel;
  return /*#__PURE__*/React__namespace.createElement(Form$1.Group, null, /*#__PURE__*/React__namespace.createElement(Form$1.Label, {
    style: {
      marginRight: ".5rem"
    },
    visuallyHidden: showLabel ? undefined : true
  }, label), Array.isArray(options) ? options.map(function (o, i) {
    var radioLabel = get_1(o, "label");
    var disabled = get_1(o, "disabled");
    return /*#__PURE__*/React__namespace.createElement(Form$1.Check, {
      key: radioLabel + i,
      inline: inline ? "yes" : undefined,
      label: radioLabel,
      name: name,
      type: "radio",
      id: name + "-" + i,
      disabled: disabled ? "yes" : undefined
    });
  }) : null, " ");
};

var registeredFields = {
  name: FieldName,
  email: FieldEmail,
  phone: FieldPhone,
  address: FieldAddress,
  select: FieldSelect,
  checkbox: FieldCheckbox,
  single: FieldSingle,
  message: FieldMessage,
  radio: FieldRadio
};
/**
 * Netlify Form Builder Utility
 * @param {string | Component} title
 * @param {array} fields - array of form field options
 * @param {Object} form configuration options
 * @returns
 */

var NetlifyForm = function NetlifyForm(_ref10) {
  var title = _ref10.title,
      fields = _ref10.fields,
      config = _ref10.config; //console.log("props:", title, fields, config);

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      submitted = _useState2[0],
      setSubmitted = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      formElement = _useState4[0],
      setFormElement = _useState4[1];

  var TitleComp = title;
  var formName = get_1(config, "name");
  var thankYou = get_1(config, "thankYou", get_1(config, "thankYouPage", "/thank-you"));
  var consoleMessage = get_1(config, "consoleMessage");
  var submit = get_1(config, "submit", "Submit");
  var postUrl = get_1(config, "postUrl", "/");
  var keepDom = get_1(config, "keepDom");
  var ThankYouJsx = null; //console.log(thankYou);

  switch (true) {
    case isReactComponent(thankYou):
      ThankYouJsx = thankYou;
      break;

    case typeof thankYou === "string" && thankYou.indexOf("/") === 0:
      break;

    case typeof thankYou === "string" && thankYou.indexOf("http") === 0:
      break;

    case typeof thankYou === "string":
      ThankYouJsx = function ThankYouJsx(_ref11) {
        var thankYou = _ref11.thankYou;
        return /*#__PURE__*/React__namespace.createElement("p", null, thankYou);
      };

      break;

    default:
      ThankYouJsx = function ThankYouJsx() {
        return /*#__PURE__*/React__namespace.createElement("div", null, "Thank you for your submission!");
      };

  }

  var curForm = React.useRef();
  React.useEffect(function () {
    var current = curForm.current;
    setFormElement(current);
  }, [setFormElement]);

  var formSubmit = function formSubmit(e) {
    e.preventDefault();
    var formData = new FormData(formElement);
    var body = new URLSearchParams(formData).toString();
    fetch(postUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: body
    }).then(function () {
      if (consoleMessage) {
        console.log("Form submit success: ", body);
      }
    }).then(function () {
      if (!ThankYouJsx) {
        window.location.href = thankYou;
      } else {
        setSubmitted(true);
      }
    })["catch"](function (error) {
      return console.log(error);
    });
  };

  var showForm = ThankYouJsx && keepDom;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, submitted && !showForm ? /*#__PURE__*/React__namespace.createElement(ThankYouJsx, null) : /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", {
    style: {
      display: submitted && showForm ? "none" : "block"
    }
  }, typeof title === "string" ? /*#__PURE__*/React__namespace.createElement("h2", null, title) : isReactComponent(title) ? /*#__PURE__*/React__namespace.createElement(TitleComp, null) : null, /*#__PURE__*/React__namespace.createElement(Form$1, {
    name: formName,
    method: "post",
    ref: curForm,
    "data-netlify": "true",
    onSubmit: formSubmit
  }, /*#__PURE__*/React__namespace.createElement("input", {
    type: "hidden",
    name: "form-name",
    value: formName
  }), /*#__PURE__*/React__namespace.createElement(Container$1, {
    fluid: "true"
  }, Array.isArray(fields) ? fields.map(function (field, i) {
    var fieldType = get_1(field, "as");
    var FieldComp = get_1(field, "Component");
    var FieldJsx = FieldComp && isReactComponent(FieldComp) ? FieldComp : get_1(registeredFields, "[".concat(fieldType, "]"), NullComponent$1);
    var props = get_1(field, "props");
    return /*#__PURE__*/React__namespace.createElement(FieldJsx, _extends$1({
      key: fieldType + i
    }, props));
  }) : null, /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, {
    className: "submit-col"
  }, /*#__PURE__*/React__namespace.createElement(Button$1, {
    type: "submit"
  }, submit)))))), submitted && showForm ? /*#__PURE__*/React__namespace.createElement(Row$1, null, /*#__PURE__*/React__namespace.createElement(Col$1, null, /*#__PURE__*/React__namespace.createElement(ThankYouJsx, null))) : null));
};
/**
 *
 * @param {Array} arr
 * @param {number} per - an interger representing max items per page
 * @returns {Object} - an array of arrays representing each page
 */


var paginateArray = function paginateArray(arr) {
  var per = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

  if (Array.isArray(arr)) {
    var totalPages = Math.ceil(arr.length / per);
    var pages = [];

    for (var i = 0; i < totalPages; i++) {
      pages[i] = arr.slice(i * per, i * per + per);
    }

    return pages;
  } else {
    return [];
  }
};
/**
 * Class that represets paginated items
 */


var Pagination =
/**
 * Declare pagination
 * @param {Array} arr - an interger representing max items per page
 * @param {number} per - an array of arrays representing each page
 */
function Pagination(arr) {
  var per = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

  _classCallCheck(this, Pagination);

  var pages = paginateArray(arr, per);
  this.pages = pages;
  this.perPage = per;
  this.length = pages.length;
  this.total = Array.isArray(arr) ? arr.length : 0;
};

function _interopDefault$1(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React__default = _interopDefault$1(React__default$1["default"]);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      } // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React__default$1["default"].PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

var lib = withSideEffect;
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView; // Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    } // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.


    var it;

    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      }

      return true;
    }

    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      return true;
    } // END: Modifications


    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    } // END: fast-deep-equal
    // START: react-fast-compare
    // custom handling for DOM elements


    if (hasElementType && a instanceof Element) return false; // custom handling for React/Preact

    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements
        continue;
      } // all other properties should be traversed as usual


      if (!equal(a[keys[i]], b[keys[i]])) return false;
    } // END: react-fast-compare
    // START: fast-deep-equal


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
};

var ATTRIBUTE_NAMES = {
  BODY: "bodyAttributes",
  HTML: "htmlAttributes",
  TITLE: "titleAttributes"
};
var TAG_NAMES = {
  BASE: "base",
  BODY: "body",
  HEAD: "head",
  HTML: "html",
  LINK: "link",
  META: "meta",
  NOSCRIPT: "noscript",
  SCRIPT: "script",
  STYLE: "style",
  TITLE: "title"
};
var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
  return TAG_NAMES[name];
});
var TAG_PROPERTIES = {
  CHARSET: "charset",
  CSS_TEXT: "cssText",
  HREF: "href",
  HTTPEQUIV: "http-equiv",
  INNER_HTML: "innerHTML",
  ITEM_PROP: "itemprop",
  NAME: "name",
  PROPERTY: "property",
  REL: "rel",
  SRC: "src",
  TARGET: "target"
};
var REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
};
var HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate"
};
var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
  obj[REACT_TAG_MAP[key]] = key;
  return obj;
}, {});
var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
  var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (encode === false) {
    return String(str);
  }

  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
  var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
  var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

  if (innermostTemplate && innermostTitle) {
    // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function () {
      return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
  }

  var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
  return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
  return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
  return propsList.filter(function (props) {
    return typeof props[tagType] !== "undefined";
  }).map(function (props) {
    return props[tagType];
  }).reduce(function (tagAttrs, current) {
    return _extends({}, tagAttrs, current);
  }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
  return propsList.filter(function (props) {
    return typeof props[TAG_NAMES.BASE] !== "undefined";
  }).map(function (props) {
    return props[TAG_NAMES.BASE];
  }).reverse().reduce(function (innermostBaseTag, tag) {
    if (!innermostBaseTag.length) {
      var keys = Object.keys(tag);

      for (var i = 0; i < keys.length; i++) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();

        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
          return innermostBaseTag.concat(tag);
        }
      }
    }

    return innermostBaseTag;
  }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
  // Calculate list of tags, giving priority innermost component (end of the propslist)
  var approvedSeenTags = {};
  return propsList.filter(function (props) {
    if (Array.isArray(props[tagName])) {
      return true;
    }

    if (typeof props[tagName] !== "undefined") {
      warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
    }

    return false;
  }).map(function (props) {
    return props[tagName];
  }).reverse().reduce(function (approvedTags, instanceTags) {
    var instanceSeenTags = {};
    instanceTags.filter(function (tag) {
      var primaryAttributeKey = void 0;
      var keys = Object.keys(tag);

      for (var i = 0; i < keys.length; i++) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase(); // Special rule with link tags, since rel and href are both primary tags, rel takes priority

        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
          primaryAttributeKey = lowerCaseAttributeKey;
        } // Special case for innerHTML which doesn't work lowercased


        if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
          primaryAttributeKey = attributeKey;
        }
      }

      if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
        return false;
      }

      var value = tag[primaryAttributeKey].toLowerCase();

      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }

      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }

      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }

      return false;
    }).reverse().forEach(function (tag) {
      return approvedTags.push(tag);
    }); // Update seen tags with tags from this instance

    var keys = Object.keys(instanceSeenTags);

    for (var i = 0; i < keys.length; i++) {
      var attributeKey = keys[i];
      var tagUnion = objectAssign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
      approvedSeenTags[attributeKey] = tagUnion;
    }

    return approvedTags;
  }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
  for (var i = propsList.length - 1; i >= 0; i--) {
    var props = propsList[i];

    if (props.hasOwnProperty(property)) {
      return props[property];
    }
  }

  return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
  return {
    baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
    bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
    defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
    encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
    htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
    linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
    metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
    noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
    onChangeClientState: getOnChangeClientState(propsList),
    scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
    styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
    title: getTitleFromPropsList(propsList),
    titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
  };
};

var rafPolyfill = function () {
  var clock = Date.now();
  return function (callback) {
    var currentTime = Date.now();

    if (currentTime - clock > 16) {
      clock = currentTime;
      callback(currentTime);
    } else {
      setTimeout(function () {
        rafPolyfill(callback);
      }, 0);
    }
  };
}();

var cafPolyfill = function cafPolyfill(id) {
  return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
  return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
  if (_helmetCallback) {
    cancelAnimationFrame(_helmetCallback);
  }

  if (newState.defer) {
    _helmetCallback = requestAnimationFrame(function () {
      commitTagChanges(newState, function () {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
  var baseTag = newState.baseTag,
      bodyAttributes = newState.bodyAttributes,
      htmlAttributes = newState.htmlAttributes,
      linkTags = newState.linkTags,
      metaTags = newState.metaTags,
      noscriptTags = newState.noscriptTags,
      onChangeClientState = newState.onChangeClientState,
      scriptTags = newState.scriptTags,
      styleTags = newState.styleTags,
      title = newState.title,
      titleAttributes = newState.titleAttributes;
  updateAttributes(TAG_NAMES.BODY, bodyAttributes);
  updateAttributes(TAG_NAMES.HTML, htmlAttributes);
  updateTitle(title, titleAttributes);
  var tagUpdates = {
    baseTag: updateTags(TAG_NAMES.BASE, baseTag),
    linkTags: updateTags(TAG_NAMES.LINK, linkTags),
    metaTags: updateTags(TAG_NAMES.META, metaTags),
    noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
    scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
    styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
  };
  var addedTags = {};
  var removedTags = {};
  Object.keys(tagUpdates).forEach(function (tagType) {
    var _tagUpdates$tagType = tagUpdates[tagType],
        newTags = _tagUpdates$tagType.newTags,
        oldTags = _tagUpdates$tagType.oldTags;

    if (newTags.length) {
      addedTags[tagType] = newTags;
    }

    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });
  cb && cb();
  onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
  return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
  if (typeof title !== "undefined" && document.title !== title) {
    document.title = flattenArray(title);
  }

  updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
  var elementTag = document.getElementsByTagName(tagName)[0];

  if (!elementTag) {
    return;
  }

  var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
  var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
  var attributesToRemove = [].concat(helmetAttributes);
  var attributeKeys = Object.keys(attributes);

  for (var i = 0; i < attributeKeys.length; i++) {
    var attribute = attributeKeys[i];
    var value = attributes[attribute] || "";

    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }

    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }

    var indexToSave = attributesToRemove.indexOf(attribute);

    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }

  for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
    elementTag.removeAttribute(attributesToRemove[_i]);
  }

  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
    elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
  }
};

var updateTags = function updateTags(type, tags) {
  var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
  var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
  var oldTags = Array.prototype.slice.call(tagNodes);
  var newTags = [];
  var indexToDelete = void 0;

  if (tags && tags.length) {
    tags.forEach(function (tag) {
      var newElement = document.createElement(type);

      for (var attribute in tag) {
        if (tag.hasOwnProperty(attribute)) {
          if (attribute === TAG_PROPERTIES.INNER_HTML) {
            newElement.innerHTML = tag.innerHTML;
          } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag.cssText));
            }
          } else {
            var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
            newElement.setAttribute(attribute, value);
          }
        }
      }

      newElement.setAttribute(HELMET_ATTRIBUTE, "true"); // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.

      if (oldTags.some(function (existingTag, index) {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }

  oldTags.forEach(function (tag) {
    return tag.parentNode.removeChild(tag);
  });
  newTags.forEach(function (tag) {
    return headElement.appendChild(tag);
  });
  return {
    oldTags: oldTags,
    newTags: newTags
  };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
  return Object.keys(attributes).reduce(function (str, key) {
    var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
    return str ? str + " " + attr : attr;
  }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
  var attributeString = generateElementAttributesAsString(attributes);
  var flattenedTitle = flattenArray(title);
  return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
  return tags.reduce(function (str, tag) {
    var attributeHtml = Object.keys(tag).filter(function (attribute) {
      return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
    }).reduce(function (string, attribute) {
      var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
      return string ? string + " " + attr : attr;
    }, "");
    var tagContent = tag.innerHTML || tag.cssText || "";
    var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
    return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
  }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
  var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(attributes).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key] || key] = attributes[key];
    return obj;
  }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
  var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(props).reduce(function (obj, key) {
    obj[HTML_TAG_MAP[key] || key] = props[key];
    return obj;
  }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
  var _initProps; // assigning into an array to define toString function on it


  var initProps = (_initProps = {
    key: title
  }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
  var props = convertElementAttributestoReactProps(attributes, initProps);
  return [React__default$1["default"].createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
  return tags.map(function (tag, i) {
    var _mappedTag;

    var mappedTag = (_mappedTag = {
      key: i
    }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
    Object.keys(tag).forEach(function (attribute) {
      var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

      if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
        var content = tag.innerHTML || tag.cssText;
        mappedTag.dangerouslySetInnerHTML = {
          __html: content
        };
      } else {
        mappedTag[mappedAttribute] = tag[attribute];
      }
    });
    return React__default$1["default"].createElement(type, mappedTag);
  });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
  switch (type) {
    case TAG_NAMES.TITLE:
      return {
        toComponent: function toComponent() {
          return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
        },
        toString: function toString() {
          return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
        }
      };

    case ATTRIBUTE_NAMES.BODY:
    case ATTRIBUTE_NAMES.HTML:
      return {
        toComponent: function toComponent() {
          return convertElementAttributestoReactProps(tags);
        },
        toString: function toString() {
          return generateElementAttributesAsString(tags);
        }
      };

    default:
      return {
        toComponent: function toComponent() {
          return generateTagsAsReactComponent(type, tags);
        },
        toString: function toString() {
          return generateTagsAsString(type, tags, encode);
        }
      };
  }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
  var baseTag = _ref.baseTag,
      bodyAttributes = _ref.bodyAttributes,
      encode = _ref.encode,
      htmlAttributes = _ref.htmlAttributes,
      linkTags = _ref.linkTags,
      metaTags = _ref.metaTags,
      noscriptTags = _ref.noscriptTags,
      scriptTags = _ref.scriptTags,
      styleTags = _ref.styleTags,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      titleAttributes = _ref.titleAttributes;
  return {
    base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
    bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
    htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
    link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
    meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
    noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
    script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
    style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
    title: getMethodsForTag(TAG_NAMES.TITLE, {
      title: title,
      titleAttributes: titleAttributes
    }, encode)
  };
};

var Helmet = function Helmet(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    inherits(HelmetWrapper, _React$Component);

    function HelmetWrapper() {
      classCallCheck(this, HelmetWrapper);
      return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return !reactFastCompare(this.props, nextProps);
    };

    HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
      if (!nestedChildren) {
        return null;
      }

      switch (child.type) {
        case TAG_NAMES.SCRIPT:
        case TAG_NAMES.NOSCRIPT:
          return {
            innerHTML: nestedChildren
          };

        case TAG_NAMES.STYLE:
          return {
            cssText: nestedChildren
          };
      }

      throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
    };

    HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
      var _babelHelpers$extends;

      var child = _ref.child,
          arrayTypeChildren = _ref.arrayTypeChildren,
          newChildProps = _ref.newChildProps,
          nestedChildren = _ref.nestedChildren;
      return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
    };

    HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
      var _babelHelpers$extends2, _babelHelpers$extends3;

      var child = _ref2.child,
          newProps = _ref2.newProps,
          newChildProps = _ref2.newChildProps,
          nestedChildren = _ref2.nestedChildren;

      switch (child.type) {
        case TAG_NAMES.TITLE:
          return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

        case TAG_NAMES.BODY:
          return _extends({}, newProps, {
            bodyAttributes: _extends({}, newChildProps)
          });

        case TAG_NAMES.HTML:
          return _extends({}, newProps, {
            htmlAttributes: _extends({}, newChildProps)
          });
      }

      return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
    };

    HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
      var newFlattenedProps = _extends({}, newProps);

      Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
        var _babelHelpers$extends4;

        newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
      });
      return newFlattenedProps;
    };

    HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
      if (process.env.NODE_ENV !== "production") {
        if (!VALID_TAG_NAMES.some(function (name) {
          return child.type === name;
        })) {
          if (typeof child.type === "function") {
            return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
          }

          return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
        }

        if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
          return typeof nestedChild !== "string";
        }))) {
          throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
        }
      }

      return true;
    };

    HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
      var _this2 = this;

      var arrayTypeChildren = {};
      React__default$1["default"].Children.forEach(children, function (child) {
        if (!child || !child.props) {
          return;
        }

        var _child$props = child.props,
            nestedChildren = _child$props.children,
            childProps = objectWithoutProperties(_child$props, ["children"]);
        var newChildProps = convertReactPropstoHtmlAttributes(childProps);

        _this2.warnOnInvalidChildren(child, nestedChildren);

        switch (child.type) {
          case TAG_NAMES.LINK:
          case TAG_NAMES.META:
          case TAG_NAMES.NOSCRIPT:
          case TAG_NAMES.SCRIPT:
          case TAG_NAMES.STYLE:
            arrayTypeChildren = _this2.flattenArrayTypeChildren({
              child: child,
              arrayTypeChildren: arrayTypeChildren,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;

          default:
            newProps = _this2.mapObjectTypeChildren({
              child: child,
              newProps: newProps,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;
        }
      });
      newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
      return newProps;
    };

    HelmetWrapper.prototype.render = function render() {
      var _props = this.props,
          children = _props.children,
          props = objectWithoutProperties(_props, ["children"]);

      var newProps = _extends({}, props);

      if (children) {
        newProps = this.mapChildrenToProps(children, newProps);
      }

      return React__default$1["default"].createElement(Component, newProps);
    };

    createClass(HelmetWrapper, null, [{
      key: "canUseDOM",
      // Component.peek comes from react-side-effect:
      // For testing, you may use a static peek() method available on the returned component.
      // It lets you get the current state without resetting the mounted instance stack.
      // Don’t use it for anything other than testing.

      /**
       * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
       * @param {Object} bodyAttributes: {"className": "root"}
       * @param {String} defaultTitle: "Default Title"
       * @param {Boolean} defer: true
       * @param {Boolean} encodeSpecialCharacters: true
       * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
       * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
       * @param {Array} meta: [{"name": "description", "content": "Test description"}]
       * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
       * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
       * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
       * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
       * @param {String} title: "Title"
       * @param {Object} titleAttributes: {"itemprop": "name"}
       * @param {String} titleTemplate: "MySite.com - %s"
       */
      set: function set$$1(canUseDOM) {
        Component.canUseDOM = canUseDOM;
      }
    }]);
    return HelmetWrapper;
  }(React__default$1["default"].Component), _class.propTypes = {
    base: PropTypes__default["default"].object,
    bodyAttributes: PropTypes__default["default"].object,
    children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]),
    defaultTitle: PropTypes__default["default"].string,
    defer: PropTypes__default["default"].bool,
    encodeSpecialCharacters: PropTypes__default["default"].bool,
    htmlAttributes: PropTypes__default["default"].object,
    link: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    meta: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    noscript: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    onChangeClientState: PropTypes__default["default"].func,
    script: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    style: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    title: PropTypes__default["default"].string,
    titleAttributes: PropTypes__default["default"].object,
    titleTemplate: PropTypes__default["default"].string
  }, _class.defaultProps = {
    defer: true,
    encodeSpecialCharacters: true
  }, _class.peek = Component.peek, _class.rewind = function () {
    var mappedState = Component.rewind();

    if (!mappedState) {
      // provide fallback if mappedState is undefined
      mappedState = mapStateOnServer({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: true,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
      });
    }

    return mappedState;
  }, _temp;
};

var NullComponent = function NullComponent() {
  return null;
};

var HelmetSideEffects = lib(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var WmkSeo = {};

var sanitizeSocialImageUrl = function sanitizeSocialImageUrl(url) {
  var _url = typeof url === "string" || url instanceof String ? url : "";

  return _url.indexOf("//") === 0 ? "https:" + _url : _url;
};

WmkSeo.Meta = function (_ref) {
  var description = _ref.description,
      lang = _ref.lang,
      title = _ref.title,
      path = _ref.path,
      slug = _ref.slug,
      ogImage = _ref.ogImage,
      twitterImage = _ref.twitterImage,
      twitterHandle = _ref.twitterHandle,
      baseUrl = _ref.baseUrl,
      siteTitle = _ref.siteTitle;
  var slugVar = !slug || slug === "/" ? "" : slug;
  var pathVar = !slug || slug === "/" ? "" : path;
  var metaProps = [{
    name: "description",
    content: description
  }, {
    property: "og:title",
    content: title
  }, {
    property: "og:description",
    content: description
  }, {
    property: "og:type",
    content: "website"
  }, {
    property: "og:url",
    content: "".concat(baseUrl).concat(pathVar).concat(slugVar)
  }, {
    property: "og:sitename",
    content: baseUrl
  }, {
    name: "twitter:card",
    content: "summary"
  }, {
    name: "twitter:creator",
    content: siteTitle
  }, {
    name: "twitter:image:alt",
    content: title
  }, {
    name: "twitter:title",
    content: title
  }, {
    name: "twitter:description",
    content: description
  }];

  if (typeof ogImage !== "undefined") {
    if (typeof ogImage === "string" || ogImage instanceof String) {
      metaProps.push({
        property: "og:image",
        content: sanitizeSocialImageUrl(ogImage)
      });
    }
  } else {
    console.log("No Open Graph Image set in WmkSeo.Meta");
  }

  if (typeof twitterImage !== "undefined") {
    if (typeof ogImage === "string" || ogImage instanceof String) {
      metaProps.push({
        name: "twitter:image",
        content: sanitizeSocialImageUrl(twitterImage)
      });
    }
  } else {
    console.log("No Twitter Image set in WmkSeo.Meta");
  }

  if (typeof twitterHandle !== "undefined") {
    if (typeof ogImage === "string" || ogImage instanceof String) {
      metaProps.push({
        name: "twitter:site",
        content: twitterHandle
      });
    }
  } else {
    console.log("No Twitter Handle set in WmkSeo.Meta");
  }

  return /*#__PURE__*/React__namespace.createElement(HelmetExport, {
    htmlAttributes: {
      lang: lang
    },
    link: [{
      rel: "canonical",
      href: "".concat(baseUrl).concat(pathVar).concat(slugVar)
    }],
    title: title,
    titleTemplate: "%s | ".concat(siteTitle),
    meta: metaProps
  });
};

WmkSeo.Meta.defaultProps = {
  lang: "en",
  description: "",
  path: "/"
};
WmkSeo.Meta.propTypes = {
  description: PropTypes__default["default"].string,
  lang: PropTypes__default["default"].string,
  title: PropTypes__default["default"].string.isRequired,
  path: PropTypes__default["default"].string,
  slug: PropTypes__default["default"].string.isRequired,
  ogImage: PropTypes__default["default"].string,
  twitterImage: PropTypes__default["default"].string,
  twitterHandle: PropTypes__default["default"].string,
  baseUrl: PropTypes__default["default"].string.isRequired,
  siteTitle: PropTypes__default["default"].string.isRequired
};

var generateGraph = function generateGraph(type) {
  var graphMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var baseUrl = arguments.length > 2 ? arguments[2] : undefined;
  var info = {
    "@type": type,
    "@id": baseUrl + "/#" + type.toLowerCase()
  };
  return _objectSpread(_objectSpread({}, info), graphMeta);
};
/* SEO SCHEMA */


WmkSeo.Schema = function (_ref2) {
  var graphs = _ref2.graphs,
      baseUrl = _ref2.baseUrl,
      siteTitle = _ref2.siteTitle;
  var website = generateGraph("WebSite", {
    name: siteTitle,
    url: baseUrl,
    publisher: {
      "@id": baseUrl + "/#organization"
    }
  }, baseUrl);
  graphs.push(website);
  var schema = {
    "@context": "https://schema.org",
    "@graph": []
  };
  graphs.forEach(function (graph) {
    return schema["@graph"].push(graph);
  });
  return /*#__PURE__*/React__namespace.createElement(HelmetExport, null, /*#__PURE__*/React__namespace.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schema)));
};

WmkSeo.Schema.defaultProps = {
  graphs: []
};
WmkSeo.Schema.propTypes = {
  graphs: PropTypes__default["default"].array,
  baseUrl: PropTypes__default["default"].string.isRequired,
  siteTitle: PropTypes__default["default"].string.isRequired
};
exports.Anchor = Anchor;
exports.Copyright = Copyright;
exports.MainLayout = MainLayout;
exports.MediaQueries = MediaQueries;
exports.NetlifyForm = NetlifyForm;
exports.Pagination = Pagination;
exports.SocialMediaIcons = SocialMediaIcons;
exports.Sticky = Sticky;
exports.UrlPaths = UrlPaths;
exports.WmkLink = WmkLink;
exports.WmkSeo = WmkSeo;
exports.generateGraph = generateGraph;